<script>
import debounce from "lodash-es/debounce";
import merge from "lodash-es/merge";
import pickBy from "lodash-es/pickBy";
import { default as queryStringUtil } from "query-string-for-all";

export default {
  props: {
    jsonUrl: { default: "" },
    accountType: { default: "" },
    categoryIds: { default: () => [] },
    sustainabilityCategoryIds: { default: () => [] },
    countryCodes: { default: () => [] },
    sellingPointOptions: { default: () => [] },
    pricingOptions: { default: () => [] },
    defaultFavorites: { default: () => [] }
  },

  data() {
    return {
      favorites: [],
      accounts: {},

      query: {
        categories: [],
        sustainabilityCategories: [],
        countries: [],
        pricing: [],
        sellingPoints: null,

        page: 1,
        sorting: "random",
        search: "",
        city: "",
        postcode: "",
        has_event_enabled: false,
        is_sustainable: false,
        onlyFavorites: false,
        key: null,
        type: null,
        openedBuyerAccountId: null
      },

      noAccessPopupOpened: false,
      fetchedForTheFirstTime: false
    };
  },

  watch: {
    "query.categories": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.sustainabilityCategories": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.countries": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.pricing": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.sellingPoints": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.has_event_enabled": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.is_sustainable": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    "query.sorting": function() {
      if (this.fetchedForTheFirstTime) {
        this.resetPage();
      }
    },
    query: {
      deep: true,
      handler: function() {
        this.updateQueryString();
      }
    }
  },

  mounted() {
    this.favorites = this.defaultFavorites;

    if (this.categoryIds.length > 0) {
      this.query.categories = [];
    }

    if (this.sustainabilityCategoryIds.length > 0) {
      this.query.sustainabilityCategories = [];
    }

    const parsedWindowLocationQuery = queryStringUtil.parse(
      window.location.search,
      {
        arrayFormat: "bracket",
        parseNumbers: true,
        parseBooleans: true
      }
    );

    if (!parsedWindowLocationQuery.sellingPoints) {
      this.toggleAllSellingPoints();
    }

    this.query.key = Math.random()
      .toString(36)
      .substr(2, 16);
    this.query.type = this.accountType;

    this.query = merge(this.query, parsedWindowLocationQuery);
  },

  methods: {
    resetPage: function() {
      this.query.page = 1;
    },

    gotoPage: function(page) {
      this.query.page = page;

      setTimeout(() => {
        window.scrollToTop();
      }, 100);
    },

    allAreSelected: function(key) {
      if (key === "categories") {
        return (
          this.categoryIds.length > 0 &&
          this.query.categories.length == this.categoryIds.length
        );
      }

      if (key === "sustainabilityCategories") {
        return (
          this.sustainabilityCategoryIds.length > 0 &&
          this.query.sustainabilityCategories.length ==
            this.sustainabilityCategoryIds.length
        );
      }

      if (key === "pricing") {
        return this.query.pricing.length == this.pricingOptions.length;
      }

      if (key === "countries") {
        return this.query.countries.length == this.countryCodes.length;
      }

      if (key === "others") {
        return this.query.is_sustainable;
      }
    },

    toggle: function(key) {
      if (key === "categories") {
        if (
          this.categoryIds.length > 0 &&
          this.query.categories.length !== this.categoryIds.length
        ) {
          return this.toggleAllCategories();
        }

        return (this.query.categories = []);
      }

      if (key === "sustainabilityCategories") {
        if (
          this.sustainabilityCategoryIds.length > 0 &&
          this.query.sustainabilityCategories.length !==
            this.sustainabilityCategoryIds.length
        ) {
          return this.toggleAllsustainabilityCategories();
        }

        return (this.query.sustainabilityCategories = []);
      }

      if (key === "pricing") {
        if (this.query.pricing.length !== this.pricingOptions.length) {
          return this.toggleAllPricing();
        }

        return (this.query.pricing = []);
      }

      if (key === "countries") {
        if (this.query.countries.length !== this.countryCodes.length) {
          return this.toggleAllCountries();
        }

        return (this.query.countries = []);
      }

      if (key === "others") {
        this.query.is_sustainable = !this.query.is_sustainable;
      }
    },

    toggleAllCategories: function() {
      if (this.categoryIds.length > 0) {
        this.query.categories = this.categoryIds;
      }
    },

    toggleAllsustainabilityCategories: function() {
      if (this.sustainabilityCategoryIds.length > 0) {
        this.query.sustainabilityCategories = this.sustainabilityCategoryIds;
      }
    },

    toggleAllCountries: function() {
      if (this.countryCodes.length > 0) {
        this.query.countries = this.countryCodes;
      }
    },

    toggleAllPricing: function() {
      if (this.pricingOptions.length > 0) {
        this.query.pricing = this.pricingOptions;
      }
    },

    toggleAllSellingPoints: function() {
      if (this.sellingPointOptions.length > 0) {
        this.query.sellingPoints = this.sellingPointOptions[0];
      }
    },

    debounceSearchQuery: debounce(function(e) {
      this.resetPage();
      this.query.search = e.target.value;
    }, 500),

    debounceCityQuery: debounce(function(e) {
      this.resetPage();
      this.query.city = e.target.value;
    }, 500),

    debouncePostcodeQuery: debounce(function(e) {
      this.resetPage();
      this.query.postcode = e.target.value;
    }, 500),

    updateQueryString: function() {
      const data = pickBy(this.query, function(value, key) {
        return key !== "key";
      });

      const stringified = queryStringUtil.stringify(data, {
        arrayFormat: "bracket",
        skipNull: true,
        skipEmptyString: true
      });

      history.replaceState(
        {},
        "",
        [window.location.pathname, stringified].filter(Boolean).join("?")
      );

      this.fetch();
    },

    toggleFavorite: function(slug) {
      axios
        .post(this.jsonUrl + "/toggle/" + slug, {
          origin: "index"
        })
        .then(response => {
          this.favorites = response.data.data;
        });
    },

    generateBuyersUrl: function(account) {
      var data = queryStringUtil.parse(window.location.search, {
        arrayFormat: "bracket",
        parseNumbers: true,
        parseBooleans: true
      });

      data.openedBuyerAccountId = account.id;

      const stringified = queryStringUtil.stringify(data, {
        arrayFormat: "bracket",
        skipNull: true,
        skipEmptyString: true
      });

      account.url = window.location.pathname + "?" + stringified;

      return account;
    },

    fetch: function() {
      const url = this.jsonUrl + window.location.search;

      axios.get(url).then(result => {
        this.accounts = result.data;

        if (this.fetchedForTheFirstTime) {
          return;
        }

        this.fetchedForTheFirstTime = true;

        if (!this.query.openedBuyerAccountId) {
          return;
        }

        this.$nextTick(function() {
          const accountElement = this.$refs[
            "account_" + this.query.openedBuyerAccountId
          ];

          accountElement[0] ? accountElement[0].$el.scrollIntoView() : null;
        });
      });
    }
  }
};
</script>
